{
  "loading": "Loading content...",
  "syncing": "Your EZ Texting group is syncing.",
  "blankSlate": "Sync your group with EZ Texting. Check out our user guide to learn more.",
  "columns": {
    "name": "Name",
    "number": "Number",
    "status": "Status"
  },
  "errors": {
    "loading": "There was a problem loading.",
    "loadingAction": "Please refresh to try again.",
    "deleteGroup": "Something went wrong deleting the group. Please try again.",
    "individualSync": "Sync error, please try again. If the problem persists, please contact support.",
    "getGroup": "There was a problem updating group data after contact sync"
  },
  "warnings": {
    "individualSync": "Sync error, please review contact information and try again."
  },
  "success": {
    "sync": "Request received. Syncing contacts may take some time.",
    "individualSync": "Your contact was successfully synced."
  },
  "buttons": {
    "cta": "Sync Group",
    "edit": "Edit Group"
  },
  "banners": {
    "attention": "Some of your contacts didn't sync properly. Review the status below, then click the link to fix each record. Re-sync the group to see your changes."
  }
}
